var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.params.data.tracking.id && _vm.padrao && _vm.params.data.carrier.name === 'CORREIOS')?_c('feather-icon',{attrs:{"icon":"StarIcon","svgClasses":"h-5 w-5 hover:text-primary cursor-pointer","title":_vm.padrao},on:{"click":_vm.save_changes}}):_vm._e(),_c('span',{attrs:{"title":_vm.prettyKind}},[_vm._v(" "+_vm._s(_vm.prettyKind))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }